import { useLocalSearchParams } from 'expo-router'

import { NotificationsCommunitiesScreen } from '@/src/features/settings/ui/screens/NotificationsCommunitiesScreen'

export default function () {
  const searchParams = useLocalSearchParams()
  return <NotificationsCommunitiesScreen searchParams={searchParams} />
}
